/**
 * This file is part of Barbacana Customizations.
 *
 * Barbacana Customizations is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * Barbacana Customizations is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * Barbacana Customizations.  If not, see <https://www.gnu.org/licenses/>.
 */

import './view.scss';

{
	document.querySelectorAll( '.wp-block-barbacana-project-gallery' ).forEach( setupList );

	function setupList( list ) {
		if ( list.children.length === 0 ) {
			return;
		}
		const cloned = list.children.item( 0 ).cloneNode( true );
		list.appendChild( cloned );

		let lastTop = list.scrollTop;
		list.addEventListener( 'scroll', function ( ev ) {
			const lastRect = cloned.getBoundingClientRect();
			const padding = 10;
			if ( list.scrollTop > lastTop ) {
				if ( list.scrollTop >= list.scrollHeight - lastRect.height - padding ) {
					list.scrollTo( 0, padding );
				}
			} else if ( list.scrollTop < lastTop ) {
				if ( list.scrollTop <= padding ) {
					list.scrollTo( 0, list.scrollHeight - lastRect.height - padding );
				}
			}
			lastTop = list.scrollTop;
		} );
	}
}
